

























































import {Vue, Component} from 'vue-property-decorator';
import {
  GetJobDutyService,
  PutJobDutyDisplayOrderRequest,
  PostJobDutyRequest,
  DeleteJobDutyRequest,
  PutJobDutyRequest,
  PutJobDutyValidation,
  PostJobDutyValidation,
  PostJobDutyGroup
} from 'supporter';
import { pattern } from '@/const/regex'
@Component({})
export default class Jobduty extends Vue {
  private formEdited: boolean = false;
  private GetJobdutyData: GetJobDutyService[] = [];
  private selectedJobdutyData: GetJobDutyService | {} = {};
  private indexGetJobdutyService: number = 1;
  private addedJobdutyGroup: PostJobDutyGroup | null = null;
  private displayInput = {}
  private async tabChanged() {
    const {jobDutyNo} = this.selectedJobdutyData as GetJobDutyService;
    if (jobDutyNo) {
      const selectedJobdutyData = this.selectedJobdutyData as GetJobDutyService;
      const putRequest: PutJobDutyRequest = {
        pathParams: {
          jobDutyNo: selectedJobdutyData.jobDutyNo.toString()
        },
        data: {
          jobDutyName: selectedJobdutyData.jobDutyName.toString()
        }
      };
      const validationResult = PutJobDutyValidation(putRequest);
      if (validationResult.length) {
        this.formEdited = false;
        alert(this.$t(`ADMIN_DEPARTMENT_${validationResult[0].message}`));
        this.$api.getJobDuties().then((ret) => {
          if (ret && ret.data) {
            this.GetJobdutyData = ret.data;
            this.addedJobdutyGroup = null;
            this.selectedJobdutyData = this.GetJobdutyData[this.indexGetJobdutyService];
            this.indexGetJobdutyService = this.indexGetJobdutyService;
            // this.setDepartmentsData(this.GetJobdutyData[0], this.indexGetJobdutyService);
          }
        });
        this.formEdited = true;
      } else {
        if (window.confirm(`${this.$t('ADMIN_DEPARTMENT_UPDATE_WHETHER')}`)) {
          this.$api.putJobDuties(putRequest).then(() => {
            this.$api.getJobDuties().then((ret) => {
              if (ret && ret.data) {
                this.GetJobdutyData = ret.data;
                this.addedJobdutyGroup = null;
                this.selectedJobdutyData = this.GetJobdutyData[0];
                this.indexGetJobdutyService = 0;
                this.formEdited = false;
                // this.setDepartmentsData(this.GetJobdutyData[0], this.indexGetJobdutyService);
                alert(this.$t('ADMIN_DEPARTMENT_UPDATE_SUCCESS'));
              }
            });
          });
          return true;
        } else {
          return false;
        }
      }
    } else {
      const selectedJobdutyData = this.selectedJobdutyData as GetJobDutyService;
      const postRequest: PostJobDutyRequest = {
        data: {
          jobDutyName: selectedJobdutyData.jobDutyName.toString()
        }
      };
      const validationResult = PostJobDutyValidation(postRequest);
      if (validationResult.length) {
        this.formEdited = false;
        alert(this.$t(`ADMIN_DEPARTMENT_${validationResult[0].message}`));
        const text = this.$t('ADMIN_DEPARTMENT_NEW_GROUP2');
        const jobdutyData = {
          jobDutyName: text.toString()
        };
        this.addedJobdutyGroup = jobdutyData;
        this.setJobdutyData(this.addedJobdutyGroup, this.indexGetJobdutyService);
        this.formEdited = true;
      } else {
        if (window.confirm(`${this.$t('ADMIN_DEPARTMENT_UPDATE_WHETHER')}`)) {
          this.$api.postJobDuties(postRequest).then(() => {
            this.$api.getJobDuties().then((ret) => {
              if (ret && ret.data) {
                this.GetJobdutyData = ret.data;
                this.addedJobdutyGroup = null;
                this.selectedJobdutyData = this.GetJobdutyData[0];
                this.indexGetJobdutyService = 0;
                this.formEdited = false;
                // this.setDepartmentsData(this.GetJobdutyData[0], this.indexGetJobdutyService);
                alert(this.$t('ADMIN_DEPARTMENT_UPDATE_SUCCESS'));
              }
            });
          });
          return true;
        } else {
          return false;
        }
      }
    }
  }
  private created() {
    this.$api.getJobDuties().then((ret) => {
      if (ret && ret.data) {
        this.GetJobdutyData = ret.data;
        this.setJobdutyData(this.GetJobdutyData[0], 0);
      }
    });
    // const selectedJobdutyData = this.selectedJobdutyData as GetJobDutyService;
  }
  private selectStatus: any = {};
  private setJobdutyData(jobdutyData: any, index: any): void {
    Object.assign(this.selectStatus, jobdutyData);
    if (this.formEdited) {
      alert(this.$t('ADMIN_DEPARTMENT_CONFIRM'));
      return;
    }
    this.selectedJobdutyData = jobdutyData;
    this.indexGetJobdutyService = index;
  }
  private displayChange(direction: string) {
    const selectedJobdutyData = this.selectedJobdutyData as GetJobDutyService;

    if (direction == 'DOWN') {
      if (this.indexGetJobdutyService == this.GetJobdutyData.length - 1) {
        this.indexGetJobdutyService = this.GetJobdutyData.length - 1;
        // alert(this.$t('ADMIN_DEPARTMENT_ERRMESSAGE'));
      } else {
        this.indexGetJobdutyService += 1;
      }
    } else {
      if (this.indexGetJobdutyService == 0) {
        this.indexGetJobdutyService = 0;
        // alert(this.$t('ADMIN_DEPARTMENT_ERRMESSAGE'));
      } else {
        this.indexGetJobdutyService -= 1;
      }
    }
    if (selectedJobdutyData.hasOwnProperty('jobDutyNo') && !this.formEdited) {
      const putRequest: PutJobDutyDisplayOrderRequest = {
        pathParams: {
          jobDutyNo: JSON.stringify(selectedJobdutyData.jobDutyNo)
        },
        data: {
          // newOrder: direction == 'DOWN' ? ++this.indexGetJobdutyService : --this.indexGetJobdutyService
          newOrder: direction == 'DOWN' ? Math.min(this.indexGetJobdutyService, this.GetJobdutyData.length - 1) : Math.max(this.indexGetJobdutyService, 0)
        }
      };
      this.$api.putJobDutiesDisplayOrder(putRequest).then(() => {
        this.$api.getJobDuties().then((ret) => {
          if (ret && ret.data) {
            this.GetJobdutyData = ret.data;
            // this.setDepartmentsData(this.GetJobdutyData[0], this.indexGetJobdutyService);
          }
        });
      });
    } else {
      alert(this.$t('ADMIN_DEPARTMENT_CONFIRM'));
    }
  }
  private addGroup() {
    const text = this.$t('ADMIN_DEPARTMENT_NEW_GROUP2');
    const jobdutyData = {
      jobDutyName: text.toString()
    };
    this.addedJobdutyGroup = jobdutyData;

    this.setJobdutyData(this.addedJobdutyGroup, this.GetJobdutyData.length);
    this.formEdited = true;
  }
  private deleteGroup() {
    const selectedJobdutyData = this.selectedJobdutyData as GetJobDutyService;
    if (selectedJobdutyData.jobDutyNo) {
      if (confirm(this.$t('ADMIN_DEPARTMENT_DUTY_DELETE').toString())) {
        if (selectedJobdutyData.hasOwnProperty('jobDutyNo')) {
          const deleteRequest: DeleteJobDutyRequest = {
            pathParams: {
              jobDutyNo: selectedJobdutyData.jobDutyNo.toString()
            }
          };
          this.$api.deleteJobDuties(deleteRequest).then(() => {
            this.$api.getJobDuties().then((ret) => {
              if (ret && ret.data) {
                this.GetJobdutyData = ret.data;
                this.addedJobdutyGroup = null;
                this.selectedJobdutyData = this.GetJobdutyData[0];
                this.indexGetJobdutyService = 0;
                this.formEdited = false;
              }
            });
          })
          .catch(e => {
            if(e.data.code === 'J0001'){
              alert(e.data.message);
              return false;
            }
          })
        } else {
          this.addedJobdutyGroup = null;
        }
      }
    } else {
      this.addedJobdutyGroup = null;
      this.selectedJobdutyData = this.GetJobdutyData[0];
      this.indexGetJobdutyService = 0;
      this.formEdited = false;
    }
  }
  private departmentNameChange() {
    if((this.selectedJobdutyData as any).jobDutyName){
      const reg = new RegExp(pattern['no-symbol'], 'g');
      (this.selectedJobdutyData as any).jobDutyName = (this.selectedJobdutyData as any).jobDutyName.replace(reg, '')
    }
    if ((this.selectedJobdutyData as any).jobDutyName === '') {
      alert(this.$t('ADMIN_DEPARTMENT_NAME_ERROR'));
      (this.selectedJobdutyData as any).jobDutyName = this.selectStatus.jobDutyName;
    }
  }
  private errorDepart: boolean = false;
  private keyupDepart(e){//todo
    const value = e.target.value;
    // const validate = /[\,\.\-\_a-zA-Zㄱ-힣]/g
    const validate = new RegExp(pattern['no-symbol'], 'g').test(value);
    if(validate){
      this.errorDepart = true;
    }else{
      this.errorDepart = false;
    }
    if(!value) {
      this.errorDepart = false;
    }
    e.target.value = value.replace(new RegExp(pattern['no-symbol'], 'g'),'');
    (this.selectedJobdutyData as any).jobDutyName = e.target.value;
    
  }

  private blurDepart(e){
    const value = e.target.value;
    // const validate = /[\,\.\-\_a-zA-Zㄱ-힣]/g
    const validate = new RegExp(pattern['no-symbol'], 'g').test(value);
    if(validate){
      this.errorDepart = true;
    }else{
      this.errorDepart = false;
    }
    if(!value) {
      alert(this.$t('ADMIN_DEPARTMENT_NAME_ERROR2'));
      this.$nextTick(() => {
         (this.selectedJobdutyData as any).jobDutyName = this.selectStatus.jobDutyName;
      });      
      this.errorDepart = false;
    }
    e.target.value = value.replace(new RegExp(pattern['no-symbol'], 'g'),'');
    (this.selectedJobdutyData as any).jobDutyName = e.target.value;
    this.errorDepart = false;
  }


  dblclickJobDutyName(index:number){
    this.displayInput['tui-tree-input'+index]=true
    this.$forceUpdate();
    this.$nextTick(()=>{
      $(this.$refs['tui-tree-input'+index][0]).focus();
    })
    

  }
  blurJobDutyName(index:number, e){
    this.blurDepart(e);
    this.errorDepart = false;
    this.displayInput['tui-tree-input'+index]=false
    this.$forceUpdate();
  }
}
